export const ERRORS = {
  PASSWORD_INCORRECT: 'MESSAGE.INCORRECT_PASSWORD',
  PASSWORD_RESET_REQUIRED: 'MESSAGE.PASSWORD_RESET_REQUIRED',
  READONLY: 'MESSAGE.ERROR_READ_ONLY',
  CLOSE_RIGHT: 'MESSAGE.ERROR_CLOSE_RIGHT',
  DELETE_ENTRY_RIGHT: 'MESSAGE.ERROR_DELETE_ENTRY_RIGHT',
  COMMON: 'MESSAGE.SOMETHING_WENT_WRONG'
};
